import { render, staticRenderFns } from "./RfxSetupResponse.vue?vue&type=template&id=0ac56678"
import script from "./RfxSetupResponse.vue?vue&type=script&lang=js"
export * from "./RfxSetupResponse.vue?vue&type=script&lang=js"
import style0 from "./RfxSetupResponse.vue?vue&type=style&index=0&id=0ac56678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports